import { useCallback, useEffect, useState } from "react";
import {
  listPathologyDiseasesCall,
  listPathologyOverlaysCall,
} from "../../../redux/api/pathology.api";
import { normalizePathologyOverlay } from "./pathologyOverlayUtils";

export function usePathologyStudent({ enabled, slideId }) {
  const [diseases, setDiseases] = useState([]);
  const [selectedDiseaseId, setSelectedDiseaseId] = useState("");
  const [overlays, setOverlays] = useState([]);

  const loadDiseases = useCallback(async () => {
    if (!enabled || !slideId) return;
    try {
      const res = await listPathologyDiseasesCall(slideId);
      const list = res?.diseases || [];
      setDiseases(list);
    } catch (_) {
      setDiseases([]);
    }
  }, [enabled, slideId]);

  useEffect(() => {
    loadDiseases();
  }, [loadDiseases]);

  useEffect(() => {
    if (!enabled || !slideId || !selectedDiseaseId) {
      setOverlays([]);
      return;
    }
    listPathologyOverlaysCall({ slideId, diseaseId: selectedDiseaseId })
      .then((res) =>
        setOverlays(
          (res?.overlays || [])
            .map(normalizePathologyOverlay)
            .filter(Boolean)
        )
      )
      .catch(() => setOverlays([]));
  }, [enabled, slideId, selectedDiseaseId]);

  const acceptedOverlays = overlays.filter((o) => o.status === "accepted");

  return {
    diseases,
    selectedDiseaseId,
    setSelectedDiseaseId,
    acceptedOverlays,
    hasDiseases: diseases.length > 0,
  };
}
